$(document).ready(function(){
	var options = {
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  autoplaySpeed: 4000,
	  infinite: true,
    arrows: false,
    dots: true,
    autoplay: true,
    centerPadding: 0,
    pauseOnHover: false,
    mobileFirst: true,
	};

  $('.slick').slick(options);
});